export default "__VITE_ASSET__NhbaQoFB__"